import script from "./TaxIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./TaxIndex.vue?vue&type=script&setup=true&lang=js"

import "./TaxIndex.vue?vue&type=style&index=0&id=6d30b98e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d30b98e"]])

export default __exports__